
import { Vue, Component, Prop } from 'vue-property-decorator'

import Lvl                   from "./Lvl.vue"

@Component({components: { Lvl }})
export default class Unlock extends Vue {
    @Prop({ required: true }) level! : string | number
}
